import { Mapper } from './mapper';

export const TipoInscricao = Mapper.from([
  [1, 'CNPJ'],
  [2, 'CPF'],
  [3, 'CAEPF'],
  [4, 'CNO'],
  [5, 'CGC'],
  [6, 'CEI'],
]);
